export default {
  data() {
    return {
      FilePath: process.env.VUE_APP_FILE
    }
  },
  methods: {},
  mounted() {
    // console.log(this.$store.state.Login);
  },
  computed: {
    system: {
      get() {
        return this.$store.state.system;
      }
    },
    logindata: {
      get() {
        return this.$store.state.Login;
      }
    }
  },
  components: {},
}
